var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVariantIcon = function SvgVariantIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2,
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1 1)",
    stroke: "#003E52",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.14 13V4.996H8.652l-2.52 2.532.972 1.02 1.332-1.356V13z",
    fill: "#003E52"
  }))));
};
export default SvgVariantIcon;